export default class QuestionType {
    constructor() {
        this.id = '';
        this.code = 0;
        this.name = '';
        this.description = '';
        this.weight = 1;
    }
}
